import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CommonService } from '@shared/common.service';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from '@services/lang.service';
import CONFIG from '@config/app.config';
import URL_CONFIG from '@config/url.config';
import { UtilsService } from '@services/utils.service';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { InjuryGroupsInterface, InjuryInterface } from '@interfaces/injuries.interface';

@Injectable({
    providedIn: 'root',
})
export class InjuryService {

    public constructor(
        private http: HttpClient,
        private common: CommonService,
        private trans: TranslateService,
        private lang: LangService,
    ) {
    }

    public async getInjuries(
        tournamentId?: number,
        participantId?: number,
        playerId?: number,
    ): Promise<Observable<InjuryInterface[]>> {
        let iso = this.lang.getLangSnapshot();

        if (iso == null) {
            iso = CONFIG.defaultLang;
        }

        const url = URL_CONFIG.api.getInjuries;

        const params = new HttpParams()
            .set('lang', iso)
            .set('tournamentId', tournamentId ?? '')
            .set('participantId', participantId ?? '')
            .set('playerId', playerId ?? '');

        const options = params ? { params } : {};
        return this.http.get<InjuryInterface[]>(url, options).pipe(
            catchError(this.common.errorCallback2()), // then handle the error
            tap(this.common.networkOnline()),
        );
    }

    /**
     * Get Injury Groups
     * @return [description]
     */
    public async getInjuryGroups(
        seasonId: any,
        subtournamnetId?: any,
        weekIds?: any,
        loadLatestWeekInjuries: boolean = false,
        participantId?: any,
        playerId?: any,
    ): Promise<Observable<InjuryGroupsInterface>> {
        let iso = this.lang.getLangSnapshot();

        if (iso == null) {
            iso = CONFIG.defaultLang;
        }

        if (subtournamnetId === null) {
            subtournamnetId = '';
        }
        if (weekIds === null) {
            subtournamnetId = [];
        }

        const url = UtilsService.replace(
            'seasonId',
            seasonId as string,
            URL_CONFIG.api.getInjuryGroups,
        );
        const params = new HttpParams()
            .set('lang', iso)
            .set('subtournamentId', subtournamnetId ?? '')
            .set('seasonId', seasonId ?? '')
            .set('weekIds', weekIds.join(','))
            .set('loadLatestWeekInjuries', Number(loadLatestWeekInjuries))
            .set('participantId', participantId ?? '')
            .set('playerId', playerId ?? '');

        const options = params ? { params } : {};
        return this.http.get<InjuryGroupsInterface>(url, options).pipe(
            catchError(this.common.errorCallback2()), // then handle the error
            tap(this.common.networkOnline()),
        );
    }

}
